// CSVヘッダー、フッター定義ファイル

// 仕入画面の全銀CSV出力定義
export const ZEN_FURI = {
    HEADER : [1,21,0,2618720300,"ｶ) ﾗﾝﾄﾞﾏ-ｸ",,9,"",825,"",1,9082384," ","","",""],
    TRAILER : [8,"","",""],
    END : [9," ","","","","","","","","","","","","","",""]
}

// 仕入画面の請求CSV出力定義
export const PAYMENT_CSV = {
//    HEADER : ["ID","仕入実施日","ランドマーク支店","顧客名","顧客支店名","顧客担当者名","工事番号","現場住所","現場名","契約開始日","契約終了日","特記メモ","支払額（合計）","支払額（対象見積の支払額）","税込売上合計","仕入金額（敷金除く）","調整額","仕入の追金","敷金","敷金の追金","締日ルール（1・2・3・4）","支払種別"],
    // 2023/07/24 インボイス対応
    HEADER : ["ID","仕入実施日","ランドマーク支店","顧客名","顧客支店名","顧客担当者名","工事番号","現場住所","現場名","契約開始日","契約終了日","特記メモ","賃料支払先","賃料適格事業者区分","賃料適格事業者番号","手数料支払先","手数料適格事業者区分","手数料適格事業者番号","礼金支払先","礼金適格事業者区分","礼金適格事業者番号","支払額（合計）","支払額（対象見積の支払額）","税込売上合計","仕入先名","振込先（支払）","仕入先TEL","駐車場名","契約台数","仕入金額（敷金除く）","調整額","仕入の追金","敷金","敷金の追金","締日ルール（1・2・3・4）","支払種別"],
    // TRAILER : [8,"","",""],
    // END : [9," ","","","","","","","","","","","","","",""]
}

// 請求処理画面の一覧CSV出力定義
export const INVOICE_CSV = {
    HEADER : [
        "見積ID"
        ,"請求種別"
        ,"締日"
        ,"請求状況"
        ,"仕入実施日"
        ,"請求書生成日"
        ,"請求書発行日"
        ,"支払期限日"
        ,"契約期間（開始）"
        ,"契約期間（終了）"
        ,"請求金額"
        ,"確定見積：税込・税抜区分"
        ,"確定見積：課税金額"
        ,"確定見積：税額"
        ,"確定見積：非課税金額"
        ,"顧客名（送り先）"
        ,"顧客支店名（送り先）"
        ,"請求担当者"
        ,"工事番号"
        ,"現場名"
        ,"請求関係顧客注意点"
        ,"経理課への請求メモ"
        ,"経理課への仕入メモ"
        ,"確認メモ"
    ]
}

// 請求処理画面の一覧CSV出力（売上按分）定義
export const INVOICE_CSV_APPORTIPONMENT = {
    HEADER : [
        "見積ID"
        ,"請求種別"
        ,"締日"
        ,"請求状況"
        ,"仕入実施日"
        ,"請求書生成日"
        ,"請求書発行日"
        ,"支払期限日"
        ,"計上月"
        ,"契約期間（開始）"
        ,"契約期間（終了）"
        ,"請求金額"
        ,"確定見積：税込・税抜区分"
        ,"確定見積：課税金額"
        ,"確定見積：税額"
        ,"確定見積：非課税金額"
        ,"売上高"
        ,"顧客名（送り先）"
        ,"顧客支店名（送り先）"
        ,"請求担当者"
        ,"工事番号"
        ,"現場名"
        ,"請求関係顧客注意点"
        ,"経理課への請求メモ"
        ,"経理課への仕入メモ"
        ,"確認メモ"
    ]
}

export const SECURITY_DEPOSIT_LIST = {
    HEADER : [
        "見積ID",
        "駐車場名",
        "仕入先名",
        "仕入先電話番号",
        "仕入先FAX",
        "敷金連絡状況",
        "1ヶ月前連絡日",
        "当月連絡日",
        "敷金回収状況",
        "回収済日付",
        "敷金",
        "入金合計",
        "残額",
        "最終更新者",
        "入金日1","入金額1","入金種別1","入金履歴登録者1",
        "入金日2","入金額2","入金種別2","入金履歴登録者2",
        "入金日3","入金額3","入金種別3","入金履歴登録者3",
        "入金日4","入金額4","入金種別4","入金履歴登録者4",
        "入金日5","入金額5","入金種別5","入金履歴登録者5",
        "入金日6","入金額6","入金種別6","入金履歴登録者6",
        "入金日7","入金額7","入金種別7","入金履歴登録者7",
        "入金日8","入金額8","入金種別8","入金履歴登録者8",
        "入金日9","入金額9","入金種別9","入金履歴登録者9",
        "入金日10","入金額10","入金種別10","入金履歴登録者10"
    ]
}

export const ACCOUNTS_RECEIVABLE_LIST = {
    HEADER : [
        "請求ID",
        "顧客会社名",
        "顧客支店名",
        "顧客担当者名（請求先担当者）",
        "顧客支店電話番号",
        "現場名",
        "売掛金回収状況",
        "回収済日付",
        "支払期限日",
        "請求金額",
        "変更後請求金額",
        "入金合計",
        "残額",
        "入金メモ",
        "入金",
        "銀行1",
        "銀行2",
        "銀行3",
        "振込手数料",
        "調整金額",
        "雑収入",
        "その他",
        "売上減額",
        "雑損失",
        "仮受金",
        "最終更新日時",
        "最終更新者",
        "ランドマーク支店",
        "請求書.請求メモ",
        "仕入.経理課への仕入連絡事項",
        "入金日1","入金額1","入金種別1","入金種別名1","入金履歴メモ1","入金履歴登録者1",
        "入金日2","入金額2","入金種別2","入金種別名2","入金履歴メモ2","入金履歴登録者2",
        "入金日3","入金額3","入金種別3","入金種別名3","入金履歴メモ3","入金履歴登録者3",
        "入金日4","入金額4","入金種別4","入金種別名4","入金履歴メモ4","入金履歴登録者4",
        "入金日5","入金額5","入金種別5","入金種別名5","入金履歴メモ5","入金履歴登録者5",
        "入金日6","入金額6","入金種別6","入金種別名6","入金履歴メモ6","入金履歴登録者6",
        "入金日7","入金額7","入金種別7","入金種別名7","入金履歴メモ7","入金履歴登録者7",
        "入金日8","入金額8","入金種別8","入金種別名8","入金履歴メモ8","入金履歴登録者8",
        "入金日9","入金額9","入金種別9","入金種別名9","入金履歴メモ9","入金履歴登録者9",
        "入金日10","入金額10","入金種別10","入金種別名10","入金履歴メモ10","入金履歴登録者10"
    ]
}

export const ACCOUNTS_RECEIVABLE_LIST_PER_CUSTOMER = {
    HEADER : [
        "顧客会社名",
        "請求金額",
        "変更後請求金額",
        "入金合計",
        "残額",
        "入金",
        "銀行1",
        "銀行2",
        "銀行3",
        "振込手数料",
        "調整金額",
        "雑収入",
        "雑損失",
        "売上減額",
        "その他",
        "仮受金",
    ]
}

export const SUSPENSE_RECEIPTS_ACCOUNT_LIST_PER_CUSTOMER = {
    HEADER : [
        "顧客会社名",
        "仮受金",
    ]
}

export const SURVEY_CSV = {
    HEADER : [
        "案件ID",
        "BOXステータス",
        "見積提出期限",
        "依頼種別",
        "台数",
        "顧客会社名",
        "顧客支店名",
        "顧客担当者名",
        "顧客担当者：携帯電話番号",
        "顧客担当者：固定電話番号",
        "現場名",
        "工事番号",
        "現場住所",
        "現場担当者名",
        "現場担当者電話番号",
        "調査担当者",
        "調査担当者ロックフラグ",
        "最終更新者情報：更新日",
        "最終更新者情報：更新者",
        "見積依頼受付日",
        "利用期間：開始日",
        "利用期間：終了日",
        "顧客からの要望",
        "顧客支店メモ",
        "顧客会社名（下請先）",
        "顧客支店名（下請先）",
        "顧客担当者名（下請先）",
        "顧客担当者：携帯電話番号（下請先）",
        "顧客担当者：固定電話番号（下請先）"
    ]
}